import saveAs from 'file-saver';
import { generateFDL } from './generateFDL';
import { FramingChartProps } from './types';

const getFilename = (props: FramingChartProps) =>
  `${props.canvasResolution.width}x${props.canvasResolution.height}_${props.lensSqueezeFactor}x_FramingChart.fdl`;

export async function downloadFDL(props: FramingChartProps): Promise<void> {
  try {
    const fdlContent = generateFDL(props);
    const jsonString = JSON.stringify(fdlContent, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const filename = getFilename(props);
    saveAs(blob, filename);
  } catch (error) {
    console.error('Failed to download FDL file:', error);
  }
}
